import Cookies from "js-cookie";

const SiteCookieKey = "Site";

export function getDomainSite() {
    return Cookies.get(SiteCookieKey) || null;
    try {
        const params = new URLSearchParams(window.location.search);
        const invalidateCache =
            !!params.get("ptoken") || !!params.get("passwordlessLoginToken") || !!params.get("forceResetPassword");
        if (invalidateCache) {
            return null;
        } else {
            return Cookies.get(SiteCookieKey) || null;
        }
    } catch (e) {
        return Cookies.get(SiteCookieKey) || null;
    }
}

export function setDomainSite(site) {
    return Cookies.set(SiteCookieKey, site);
}

export function removeDomainSite() {
    return Cookies.remove(SiteCookieKey);
}
